module.exports = __webpack_public_path__ + "static/Mistral-75bcb78254b5f170b3140cf2bdee72b9.woff2";